import { observer } from 'mobx-react-lite'
import { type MessageViewModel } from '@/features/messaging/MessageViewModel'
import { TextMessageContentViewModel } from '@/features/messaging/TextMessageContentViewModel'
import { TextMessageContent } from './TextMessageContent'
import { JobProgressionMessageContentContainer } from '@/features/messaging/components/ConversationView/Messages/List/JobProgressionMessageContent/JobProgressionMessageContentContainer'
import { JobProgressionMessageContentViewModel } from '@/features/messaging/JobProgressionMessageContentViewModel'

export interface MessageContentContainerProps {
  messageVm: MessageViewModel
  bubble?: boolean
  testId?: string
}

export const MessageContentContainer = observer(
  function MessageContentContainer({
    messageVm,
    bubble,
    testId,
  }: MessageContentContainerProps) {
    if (messageVm.content instanceof TextMessageContentViewModel) {
      return (
        <TextMessageContent
          testId={testId}
          htmlContent={messageVm.content.htmlContent}
          bubble={bubble}
        />
      )
    }

    if (messageVm.content instanceof JobProgressionMessageContentViewModel) {
      return <JobProgressionMessageContentContainer vm={messageVm.content} />
    }

    return <>(Unknown message content)</>
  },
)
